export default class ImageLoader {

  loadHandler: EventListener;

  constructor()
  {
    this.loadHandler = this.handleLoadEvent.bind(this);
    this.enable();
  }

  private enable(): void
  {
    document.addEventListener('load', this.loadHandler, true);

    const images = document.querySelectorAll('img.is-loading') as NodeListOf<HTMLImageElement>;
    images.forEach(image => {
      if(image.complete) {
        this.onImageLoaded(image);
      }
    });
  }

  public destroy(): void
  {
    document.removeEventListener('load', this.loadHandler);
  }

  private handleLoadEvent(event: Event): void
  {
    const target = event.target;
    if(target instanceof HTMLImageElement)
    {
      this.onImageLoaded(target);
    }
  }

  private onImageLoaded(image: HTMLImageElement): void
  {
    if(image.classList.contains('is-loading')) {
      image.classList.remove('is-loading');
    }
  }
}